module.exports = __webpack_public_path__ + "static/cal-0a8849f8709b4aaa15b6fa29aa34f987.png";